import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'

import { partnerBasicInfoFields } from '../../../../../configs'
import { LocationsAndCount } from '../../../../locationsAndCount/LocationsAndCount'

import styles from './ShowroomsEditMode.module.scss'

interface IShowroomsEditModeProps {
  isApplicable: boolean
  count: Nullable<number>
  locations: string
  isCountEnabled?: boolean
  isLocationsEnabled?: boolean
}

export const ShowroomsEditMode: FC<IShowroomsEditModeProps> = ({
  isApplicable,
  count,
  locations,
  isCountEnabled,
  isLocationsEnabled,
}) => {
  return (
    <div className={styles.root}>
      <LocationsAndCount
        isApplicable={isApplicable}
        count={count}
        countFieldName={partnerBasicInfoFields.showroomsCount}
        locations={locations}
        locationsFieldName={partnerBasicInfoFields.showroomsLocations}
        isCountEnabled={isCountEnabled}
        isLocationsEnabled={isLocationsEnabled}
      />
    </div>
  )
}
